// Code generated by Slice Machine. DO NOT EDIT.

import AvatarsEditField from "./AvatarsEditField";
import CheckboxGroupField from "./CheckboxGroupField";
import ChooseImageField from "./ChooseImageField";
import DateInputField from "./DateInputField";
import DropdownSelectField from "./DropdownSelectField";
import MultiLineTextField from "./MultiLineTextField";
import MultiTextField from "./MultiTextField";
import RadioGroupField from "./RadioGroupField";
import SingleLineTextField from "./SingleLineTextField";
import UploadPhotosField from "./UploadPhotosField";

export {
  AvatarsEditField,
  CheckboxGroupField,
  ChooseImageField,
  DateInputField,
  DropdownSelectField,
  MultiLineTextField,
  MultiTextField,
  RadioGroupField,
  SingleLineTextField,
  UploadPhotosField,
};

export const components = {
  avatars_edit_field: AvatarsEditField,
  checkbox_group_field: CheckboxGroupField,
  choose_image_field: ChooseImageField,
  date_input_field: DateInputField,
  dropdown_select_field: DropdownSelectField,
  multi_line_text_field: MultiLineTextField,
  multi_text_field: MultiTextField,
  radio_group_field: RadioGroupField,
  single_line_text_field: SingleLineTextField,
  upload_photos_field: UploadPhotosField,
};
